export enum FeatureFlagKeys {
  featurePushConsoleLogsToKibana = 'feature-push-console-logs-to-kibana',
  featureDisplayTenantDropdownForOutboundModal = 'feature-display-tenant-dropdown-for-outbound-modal',
  reconnectSoftphoneIfOutboundCallFails = 'reconnect-softphone-if-outbound-call-fails',
  featureInboxCallTransferToAgent = 'feature-inbox-call-transfer-to-agent',
  featureBillingReportDownload = 'feature-billing-report-download',
  featureWorkflowIvrMediaFileEnabled = 'feature-workflow-ivr-media-file-enabled',
  featureDisplayCampaignNameOnTaskAndToast = 'feature-display-campaign-name-on-task-and-toast',
  featureLogSoftphoneMfeConnectionInfo = 'feature-log-softphone-mfe-connection-info',
  featureLogSoftphoneConnectionInfoInterval = 'feature-log-softphone-connection-info-interval',
  // This flag is not in kebab-case due to inconsistency in LD flag naming conventions on the LD platform.
  // The flag is named "RTC-Webphone-EnableCallConnectionMonitoring" instead of "rtc-webphone-enable-call-connection-monitoring".
  // eslint-disable-next-line local-rules/require-kebab-case-feature-flags
  rtcWebphoneEnableCallConnectionMonitoring = 'RTC-Webphone-EnableCallConnectionMonitoring',
  uxChangesForJobSearchOnReclassificationDisableSearchEnableLookup = 'ux-changes-for-job-search-on-reclassification-disable-search-enable-lookup',
  featureRefreshUserStatus = 'feature-refresh-user-status',
  featurePreventMultipleRegistrations = 'feature-prevent-multiple-registrations',
  featureRtcWebphoneHandlesFetchingJwt = 'feature-rtc-webphone-handles-fetching-jwt',
  featureInboxCallWarmTransfers = 'feature-inbox-call-warm-transfers',
  featureFeUserStatusPhase2 = 'feature-fe-user-status-phase-2',
  featureRequireSeatAndBillToTenant = 'feature-require-seat-and-bill-to-tenant',
  featureVoicemailEmails = 'feature-voicemail-emails',
  featureAbandonedCallReportDownload = 'feature-abandoned-call-report-download',
  featureGracefullyHandleMicrophoneDisconnect = 'feature-gracefully-handle-microphone-disconnect',
  featureDataIntegrationEnabled = 'feature-data-integration-enabled',
  featureManagerAssist = 'feature-manager-assist',
  featureInboxIncomingTransferTag = 'feature-inbox-incoming-transfer-tag',
  featureLiveCallCenterMonitoringPage = 'feature-live-call-center-monitoring-page',
  featureShowDailyMetrics = 'feature-show-daily-metrics',
  fixDisablePopUpOnClose = 'fix-disable-pop-up-on-close',
  fixOutboundCallerIdErrors = 'fix-outbound-caller-id-errors',
  featureTransferInformationOnConversationHistory = 'feature-transfer-information-on-conversation-history',
  featureLinkCallInMonolithToCustomerAndLocationWhenCreatingNewCustomer = 'feature-link-call-in-monolith-to-customer-and-location-when-creating-new-customer',
  featureShowCompanyNameForTenant = 'feature-show-company-name-for-tenant',
  featureGlobalRecordingOverridesEnabled = 'feature-global-recording-overrides-enabled',
  featureMonitorAndResetUserStatus = 'feature-monitor-and-reset-user-status',
  featureLogUserStatusStuckInterval = 'feature-log-user-status-stuck-interval',
  featureCompanyNameInConversationHistory = 'feature-company-name-in-conversation-history',
  featureAutoRefreshUserStatus = 'feature-auto-refresh-user-status',
  featureQueueRolloverTimeoutNotificationEnabled = 'feature-queue-rollover-timeout-notification-enabled',
  featureAbandonedCallFollowUps = 'feature-abandoned-call-follow-ups',
  featureSecondChanceLeadFollowUps = 'feature-second-chance-lead-follow-ups',
  featureVirtualAssistantFollowUps = 'feature-virtual-assistant-follow-ups',
  featureVoicemailFollowUps = 'feature-voicemail-follow-ups',
  featureInboxTaskCardSettingsEnabled = 'feature-inbox-task-card-settings-enabled',
  featureManageAccounts = 'feature-manage-accounts',
  featureVirtualAgentConfiguration = 'feature-virtual-agent-configuration',
  featureRecordingDefaultsConfiguration = 'feature-recording-defaults-configuration',
  featureUserRecordingDefaultsConfiguration = 'feature-user-recording-defaults-configuration',
  featureVirtualAssistantJobBooking = 'feature-virtual-assistant-job-booking',
  featureVoicemailConfiguration = 'feature-voicemail-configuration',
  featureShowOpenCallsInConversationHistory = 'feature-show-open-calls-in-conversation-history',
  featureShowOutboundCallsRecordingInConversationHistory = 'feature-show-outbound-calls-recording-in-conversation-history',
  featureInboxCallTransfers = 'feature-inbox-call-transfers',
  featureWorkflowDragAndDrop = 'feature-workflow-drag-and-drop',
  featureEnableDeleteQueue = 'feature-enable-delete-queue',
  featureHelpCenter = 'feature-help-center',
  featureSendReportToDebugService = 'feature-send-report-to-debug-service',
  featureBulkUserActions = 'feature-bulk-user-actions',
  featureOfflineOnClose = 'feature-offline-on-close',
  featureSetCustomerOnInboundDidInteractions = 'feature-set-customer-on-inbound-did-interactions',
  featureCallTimeoutWarning = 'feature-call-timeout-warning',
  featureShowEventsInConversationDetails = 'feature-show-events-in-conversation-details',
  fixUseCallTypeDisplayTextInConversationHistory = 'fix-use-call-type-display-text-in-conversation-history',
  featureInboxCallTransferToQueue = 'feature-inbox-call-transfer-to-queue',
  featureFrontEndMetrics = 'feature-front-end-metrics',
  featureGraphqlSubscriptionsEnabled = 'feature-graphql-subscriptions-enabled',
  featureFilterVaInConversationHistory = 'feature-filter-va-in-conversation-history',
  featureQueueManagementPage = 'feature-queue-management-page',
  featureCallRecordingImmediateDownload = 'feature-call-recording-immediate-download',
  featureSpeedToLeadOutboundingV0 = 'feature-speed-to-lead-outbounding-v-0',
  featureVoiceAgentReporting = 'feature-voice-agent-reporting',
  featureEnableSoftphoneMfeDebugging = 'feature-enable-softphone-mfe-debugging',
}

/**
 * A set of all valid FeatureFlagKeys in LD (in kebab-case, generally)
 */
const AllFeatureFlagKeys = new Set(Object.values(FeatureFlagKeys));

/**
 * Checks if a key is a valid FeatureFlagKeys.
 * @param key - the key to check
 * @returns true if the key is a valid, registered member of FeatureFlagKeys, false otherwise
 */
export const isValidFeatureFlagKey = (key: string): key is FeatureFlagKeys => {
  return AllFeatureFlagKeys.has(key as FeatureFlagKeys);
};
